module.exports = __webpack_public_path__ + "static/media/ncs.2c1a1bd8.jpg";